import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../redux/store';
import { isTestEnvironment } from '../../../utils/utils';
import { SitButton } from './sitButton';
const PIXI_DATA = isTestEnvironment() ? { type: 'sit-buttons-container' } : null;
export const SitButtonsContainer = () => {
    const mySeatIndex = useAppSelector((state) => state.poker.mySeatIndex);
    const seatIndexesAvailable = useAppSelector((state) => state.poker.seatIndexesAvailable, shallowEqual);
    const seatedPlayerSeatIndexes = useAppSelector((state) => state.poker.seatedPlayerSeatIndexes, shallowEqual);
    const hasTourneyStarted = useAppSelector((state) => state.poker.tourneyProperties?.hasStarted);
    // TODO: consider calculating this in reducer:
    const emptySeatIndexes = seatIndexesAvailable.filter((seatIndex) => !seatedPlayerSeatIndexes.includes(seatIndex), shallowEqual);
    if (mySeatIndex !== undefined) {
        return null;
    }
    if (hasTourneyStarted) {
        return null;
    }
    return (_jsx(Container, { "pixi-data": PIXI_DATA, children: emptySeatIndexes.map((seatIndex, i) => (_jsx(SitButton, { seatIndex: seatIndex }, i))) }));
};
